export function displayPercent (value) {
  return value + '%'
}
